.row {
  height: 10.4rem;
  -webkit-user-select: none; /* Safari */
  -ms-user-select: none; /* IE 10 and IE 11 */
  user-select: none;
  cursor: default !important;

  &[data-has-start='false'] {
    height: 5.2rem;
  }
}

.end-of-day {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-weight: 400;
  font-size: 1.4rem;
  padding: 0.8rem;
}

.block-wrapper {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  font-weight: 400;
  font-size: 1.4rem;
}

.cell-mirror {
  padding-inline-end: 1.6rem;

  &:nth-child(2) {
    grid-column-start: 6;
  }

  &:last-child {
    justify-self: end;
    width: -webkit-fill-available;
  }
}

.date-wrapper {
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  margin-inline-start: calc(100% + 1.2rem);
  position: absolute;
  white-space: nowrap;
  color: var(--color-grayscale-ghost);
}
